<template>
  <div>
    <h1>InvitationsPage</h1>
    <pre>{{res}}</pre>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: "InvitationsPage",
  data: () => ({
  }),
  computed: {
    ...mapState({
      res: state => state.res
    }),
  },
  methods: {
  },
  components: {
  }
};
</script>

<style>
</style>
